import VideoContainer from "./Upload";
const Video = VideoContainer;
export default Video 